import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { ShopListHead } from '@widgets/shop/shop-list-head';

import { ListBody } from '@shared/ui';

export const ShopMain: FC = () => {
	return (
		<>
			<ShopListHead />
			<ListBody>
				<Outlet />
			</ListBody>
		</>
	);
};
